export class Contato {
    nmContato: string = '';
    dsEmail: string = '';
    nuTelefone: string = '';
    dsMensagem: string = '';
}
